import { render, staticRenderFns } from "./toggle-preserve.vue?vue&type=template&id=f891d1ee&scoped=true"
import script from "./toggle-preserve.vue?vue&type=script&lang=js"
export * from "./toggle-preserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f891d1ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f891d1ee')) {
      api.createRecord('f891d1ee', component.options)
    } else {
      api.reload('f891d1ee', component.options)
    }
    module.hot.accept("./toggle-preserve.vue?vue&type=template&id=f891d1ee&scoped=true", function () {
      api.rerender('f891d1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/toggle-preserve.vue"
export default component.exports